import React, {useState, useEffect} from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { Link, useNavigate,useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MainLoader from "../Loaders/MainLoader";
import CopyToClipboard from 'react-copy-to-clipboard';

function BagDetails(){
    let navigate = useNavigate();
    const { drsid } =useParams();
    const [bagdetail, setBagdetails] = useState([]);
    const [shipment, setShipment] = useState([]);
    const{headers1,headers2,logout}=AuthUser();
    const [Loading, setLoading] = useState(true); 
    useEffect(()=>{
        GetBagDetail();
    },[]);

    const GetBagDetail=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'GetBagDetail',
            headers:headers1,
            data: {
                uniqueid: drsid
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var bagdata=response.data.value;
                var shipmentdata = response.data.value.Totalshipment;
                setBagdetails(bagdata);
                setShipment(shipmentdata);
            }
            setLoading(false);
          })
          .catch(function (error) {
            setLoading(false);
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    return(
        <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer />
            {Loading==true ? <MainLoader/> :
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Bag Management</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Bag #{drsid}</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                    <div className="data_table">
                        {bagdetail.manifested =='N'?
                        <span className="status pending"> <i className="bx bx-time"></i> Pending</span>
                        :
                        <span className="status completed"> <i className="bx bx-check-double"></i> Completed</span>
                        }
                    </div>
                    <div className="btn-group ms-2 ms-lg-3">
                        <button type="button" className="btn btn-sm btn-outline-gray-700" data-bs-toggle="tooltip" aria-label="Print Bag" data-bs-original-title="Print PRS"><i className="bx bx-printer"></i> </button>
                        <button type="button" className="btn btn-sm btn-outline-gray-700" data-bs-toggle="tooltip" aria-label="Update Status" data-bs-original-title="Download Barcode Lable"><i className="bx bx-barcode"></i> </button>
                    </div>
                </div>
            </div>

            <div className="card mb-3 shipment_detail_sho">
                <div className="card-body">
                    <h5>Bag Details</h5>
                    <hr />
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <small className="text-muted">Date</small>
                            <p><strong>{bagdetail.mdate}</strong></p>
                        </div>
                        <div className="col-12 col-md-4">
                            <small className="text-muted">Source</small>
                            <p><strong>{bagdetail.bagsendercity}, {bagdetail.bagsendercountry}</strong></p>
                        </div>
                        <div className="col-12 col-md-4">
                            <small className="text-muted">Destination</small>
                            <p><strong>{bagdetail.bagreceivercity}, {bagdetail.bagreceivercountry}</strong></p>
                        </div>
                        <div className="col-12 col-md-4">
                            <small className="text-muted">Bag Unique Id</small>
                            <p><strong>{bagdetail.uniqueid}</strong></p>
                        </div>
                        <div className="col-12 col-md-4">
                            <small className="text-muted">Total Weight</small>
                            <p><strong>{bagdetail.ShipmentTotalweight}</strong></p>
                        </div>
                        <div className="col-12 col-md-4">
                            <small className="text-muted">Total Shipments</small>
                            <p><strong>{bagdetail.total_awb_no}</strong></p>
                        </div>
                    </div>
                </div>
            </div>
            
            

            <div className="row g-1">
                <div className="col-12 col-md-12">
                    <section className="data_table">
                        <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                            <table className="table table-hover">
                                <thead>
                                    <tr>				
                                        <th className="border-gray-200">AWB#</th>
                                        <th className="border-gray-200">Origin</th>
                                        <th className="border-gray-200">Destination</th>
                                        <th className="border-gray-200">Sender</th>
                                        <th className="border-gray-200">Receiver</th>
                                        <th className="border-gray-200">Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {shipment.map((ship)=>{
                                    return(
                                    <tr>
                                        <td>
                                            <div>
                                                <Link target="_blank" to={`/ShipmentDetails/${ship.slip_no}`} className="fw-bold">{ship.slip_no}</Link>
                                                <CopyToClipboard text={ship.slip_no} onCopy={()=>{toast.success(ship.slip_no+' Copied To Clipboard')}}>
                                                    <i className="bx bx-copy"></i>
                                                </CopyToClipboard>
                                            </div>
                                            <small>{ship.entrydate}</small>
                                        </td>
                                        <td><span className="fw-normal text-capitalize">{ship.sendercity}, {ship.sendercountry}</span></td>
                                        <td><span className="fw-normal text-capitalize">{ship.receivercity}, {ship.receivercountry}</span></td>
                                        <td><span className="fw-normal text-capitalize">{ship.sender_name}</span></td>
                                        <td><span className="fw-normal text-capitalize">{ship.reciever_name}</span></td>
                                        <td><span className="fw-normal"><span className="badge bg-danger">{ship.booking_mode}</span></span></td>
                                    </tr>   
                                    );
                                })}                
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
            </div>
            </>}
            <Footer/>
        </main>
        </>

    );
}
export default BagDetails;